var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLatestGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM13.22 6.97L8.75 11.44L6.78 9.47C6.63783 9.33752 6.44978 9.2654 6.25548 9.26882C6.06118 9.27225 5.87579 9.35097 5.73838 9.48838C5.60097 9.62579 5.52225 9.81118 5.51883 10.0055C5.5154 10.1998 5.58752 10.3878 5.72 10.53L8.22 13.03C8.36063 13.1705 8.55125 13.2493 8.75 13.2493C8.94875 13.2493 9.13937 13.1705 9.28 13.03L14.28 8.03C14.3537 7.96134 14.4128 7.87854 14.4538 7.78654C14.4948 7.69454 14.5168 7.59522 14.5186 7.49452C14.5204 7.39382 14.5018 7.29379 14.4641 7.2004C14.4264 7.10701 14.3703 7.02218 14.299 6.95096C14.2278 6.87974 14.143 6.8236 14.0496 6.78588C13.9562 6.74816 13.8562 6.72963 13.7555 6.73141C13.6548 6.73318 13.5555 6.75523 13.4635 6.79622C13.3715 6.83721 13.2887 6.89631 13.22 6.97Z",
    fill: "#219653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestGreenTick);
export default __webpack_public_path__ + "static/media/latestGreenTick.9179edbef58a8264e443a63d0ac2b434.svg";
export { ForwardRef as ReactComponent };